import React, { Component } from 'react';
import Icon from './Icon';
import '../../assets/styles/MostUsed/index.sass';

class MostUsed extends Component {
  constructor(props) {
    super(props);
    this.bubbleMagnitude = this.bubbleMagnitude.bind(this);
  }

  bubbleMagnitude(magnitude) {
    this.props.onIconClick(magnitude);
  }

  render() {
    return(
      <section className="MostUsed panel">
        <h1 className="panel__title">Most Used</h1>

          <ul className="MostUsed__list">
            <Icon magnitude="mass"        backgroundColor="f70af4" onIconClick={ this.bubbleMagnitude } />
            <Icon magnitude="length"      backgroundColor="23ee2c" onIconClick={ this.bubbleMagnitude } />
            <Icon magnitude="temperature" backgroundColor="fe6613" onIconClick={ this.bubbleMagnitude } />
            <Icon magnitude="area"        backgroundColor="fefb26" onIconClick={ this.bubbleMagnitude } />
            <Icon magnitude="volume"      backgroundColor="22a4e7" onIconClick={ this.bubbleMagnitude } />
            <Icon magnitude="velocity"    backgroundColor="ff2d4b" onIconClick={ this.bubbleMagnitude } />
            <Icon magnitude="time"        backgroundColor="66ff00" onIconClick={ this.bubbleMagnitude } />
            <Icon magnitude="angle"       backgroundColor="9c01dd" onIconClick={ this.bubbleMagnitude } />
            <Icon magnitude="prefix"      backgroundColor="ec0101" onIconClick={ this.bubbleMagnitude } />
            <Icon magnitude="color"       backgroundColor="c7007a" onIconClick={ this.bubbleMagnitude } />
            <Icon magnitude="currency"    backgroundColor="08effe" onIconClick={ this.bubbleMagnitude } />
            <Icon magnitude="cooking"     backgroundColor="3939ff" onIconClick={ this.bubbleMagnitude } />
          </ul>
      </section>
    );
  }
}

export default MostUsed;
